/**
 * The Status API path.
 */
export const statusAPIPath = "/status";
